import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Role } from '@data/models/role.model';
import { RolesDetailsDialogComponent } from '@shared/components/roles-details-dialog/roles-details-dialog.component';

@Component({
    selector: 'syn-message-box-acl',
    templateUrl: 'message-box-acl.component.html',
    styleUrls: ['message-box-acl.component.scss']
})

export class MessageBoxAclComponent {
    @Input() roles: Role[] = [];

    constructor(private matDialog: MatDialog) {
    }

    displayRolesInformation(event): void {
        event.preventDefault();
        event.stopPropagation();
        this.matDialog.open(RolesDetailsDialogComponent, {
            data: {
                roles: this.roles,
            },
        });
    }
}
